module.exports = __webpack_public_path__ + "assets/img/mecha-info-title-40dff428.png";